import React, { FC, useContext, useEffect, useMemo, useRef, useState } from "react";

import Button from "components_common/Button/Button";

const ReservationModifyEtcFileItem = ({
	item,
	handleDelete,
	index
}: any) => {

	
	
	return (
		<>
			<div className="flex items-center justify-between">
				<div className="flex items-center">
					<span className="text-sm font-semibold text-neutral-900 dark:text-neutral-300">	
						{item.originName}
					</span>
				</div>		
				<Button
					className={`ttnc-ButtonPrimary disabled:bg-opacity-70 bg-red-600 hover:bg-red-700 text-white !pl-4 !pr-4 !pt-1 !pb-1`}
					onClick={() => {handleDelete(item, index)}}			
				>
					삭제
				</Button>
			</div>
		</>
	);
};

export default ReservationModifyEtcFileItem;
